import { closeBanner } from '../components/SurveyBanner'

export function confirmedEstimationPage() {
    closeBanner()
}